module.exports = __webpack_public_path__ + "img/diners_club.60cdc385.png";